/**
 * Shared partner income calculation logic.
 * Used by both EposPartnerIncomeCalculator and EcomPartnerIncomeCalculator.
 */
import { useState, useMemo } from "react";

export function calculatePartnerIncome(merchantCount, businessSize, config) {
  const turnoverPerMerchant = config.turnoverBySize[businessSize];
  const totalVolume = merchantCount * turnoverPerMerchant;
  const transactionCount = totalVolume / config.avgTxnValue;

  const debitMargin = totalVolume * config.cardMix.debit * config.rateMargins.debit;
  const creditMargin = totalVolume * config.cardMix.credit * config.rateMargins.credit;
  const businessMargin = totalVolume * config.cardMix.business * config.rateMargins.business;
  const authMargin = transactionCount * config.authMarginPerTx;

  const totalGrossMargin = debitMargin + creditMargin + businessMargin + authMargin;
  const partnerMonthlyIncome = totalGrossMargin * config.partnerShare;

  return {
    totalVolume,
    transactionCount,
    totalGrossMargin,
    partnerMonthlyIncome,
    partnerAnnualIncome: partnerMonthlyIncome * 12,
  };
}

export function usePartnerState(config) {
  const [merchantCount, setMerchantCount] = useState(5);
  const [businessSize, setBusinessSize] = useState("medium");

  const result = useMemo(
    () => calculatePartnerIncome(merchantCount, businessSize, config),
    [merchantCount, businessSize, config],
  );

  return { merchantCount, setMerchantCount, businessSize, setBusinessSize, result };
}

export function formatGBP(val) {
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 2 }).format(val);
}

export function formatVolume(val) {
  if (val % 1 === 0) {
    return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(val);
  }
  return formatGBP(val);
}

export function formatNumber(val) {
  return new Intl.NumberFormat("en-GB").format(Math.round(val));
}
